import script from "./accounts.vue?vue&type=script&setup=true&lang=js"
export * from "./accounts.vue?vue&type=script&setup=true&lang=js"

import "./accounts.vue?vue&type=style&index=0&id=9ffa4e40&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ffa4e40"]])

export default __exports__